import { useMutation } from '@apollo/client';
import { SUBMIT_EUDR_RISK_ANALYSIS } from 'graphql/secure/mutations/dueDiligenceProcess.mutations';
import { ISubmitEUDRRiskAnalysisInput } from 'graphql/secure/mutations/types/dueDiligenceProcess-mutation.types';
import { EXPORT_GEO_DATA, PROCESS_GEO_DATAS } from 'graphql/secure/mutations/geoData.mutations';
import {
  IExportGeoDataInput,
  IProcessGeoDatasPayload,
} from 'graphql/secure/mutations/types/geodata-mutation.types';

const useGeoDataMutation = () => {
  const [_processGeoDatas] = useMutation<
    { processGeoDatas: IProcessGeoDatasPayload },
    { ids: string[] }
  >(PROCESS_GEO_DATAS);

  const [_submitEUDRRiskAnalysis] = useMutation<unknown, { input: ISubmitEUDRRiskAnalysisInput }>(
    SUBMIT_EUDR_RISK_ANALYSIS,
    { refetchQueries: ['GetGeoDataProcess'] }
  );

  const startGeoDatasProcessing = (ids: string[]) =>
    _processGeoDatas({
      variables: {
        ids,
      },
      refetchQueries: [
        'GetGeoDataProcess',
        'GetDataset',
        'GetDatasetTableRepresentation',
        'GetDatasetSites',
      ],
    });

  const submitEudrRiskAnalysis = (geoDataBatches: ISubmitEUDRRiskAnalysisInput) =>
    _submitEUDRRiskAnalysis({
      variables: {
        input: geoDataBatches,
      },
    });

  const [_exportGeoData] = useMutation<
    { exportGeoData: { fileUrl: string } },
    { input: IExportGeoDataInput }
  >(EXPORT_GEO_DATA);

  const exportGeoData = async ({
    geoDataId,
    exportType,
    exportFormat,
  }: {
    geoDataId: string;
    exportType: IExportGeoDataInput['exportType'];
    exportFormat: IExportGeoDataInput['exportFormat'];
  }) => {
    return await _exportGeoData({
      variables: {
        input: {
          geoDataId,
          exportType,
          exportFormat,
        },
      },
    });
  };

  return {
    submitEudrRiskAnalysis,
    startGeoDatasProcessing,
    exportGeoData,
  };
};

export default useGeoDataMutation;
